import { FC } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

type TProps = {
  content: string;
  className?: string;
};

export const MarkdownView: FC<TProps> = ({ content, className = "" }) => (
  <div
    className={`prose prose-sm max-w-none text-[13px] leading-[20px] text-gray-800 prose-headings:mb-1 prose-headings:mt-3 prose-headings:text-gray-900 prose-p:my-1.5 prose-ul:my-1.5 prose-ol:my-1.5 prose-li:my-0 prose-table:text-[12px] ${className}`}
  >
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
  </div>
);
